export const ROOT_ADMIN_HOSTS = new Set(['admin.mogoo.co.kr']);

const LOCAL_HOST_PATTERN = /^(localhost|127\.0\.0\.1)$|^192\.168\.|^10\.|^172\.(1[6-9]|2\d|3[01])\./;

const getCurrentLocation = () => {
  if (typeof window === 'undefined') {
    return { protocol: 'http:', hostname: 'localhost' };
  }
  return window.location;
};

const withoutTrailingSlash = (value) => value.replace(/\/+$/, '');

export const isLocalHostname = (hostname = '') => LOCAL_HOST_PATTERN.test(hostname);

export const getApiOrigin = ({
  env = process.env,
  locationLike = getCurrentLocation(),
} = {}) => {
  const explicitOrigin = env.REACT_APP_BACKEND_URL || env.REACT_APP_BACKEND_ORIGIN;
  if (explicitOrigin) return withoutTrailingSlash(explicitOrigin);

  const hostname = locationLike.hostname || 'localhost';
  if (isLocalHostname(hostname)) return `http://${hostname}:3000`;

  const protocol = locationLike.protocol || 'https:';
  return `${protocol}//${hostname}`;
};

export const getApiBaseURL = (options = {}) => {
  const env = options.env ?? process.env;
  const explicitBaseURL = env.REACT_APP_API_BASE_URL || env.REACT_APP_API_URL;
  if (explicitBaseURL) return withoutTrailingSlash(explicitBaseURL);

  return `${getApiOrigin(options)}/api/v1`;
};

export const getLoginURL = ({
  env = process.env,
  locationLike = getCurrentLocation(),
  publicUrl = env.PUBLIC_URL,
} = {}) => {
  if (ROOT_ADMIN_HOSTS.has(locationLike.hostname)) return '/login';

  if (!publicUrl || publicUrl === '/' || publicUrl === '.') return '/login';
  return `${withoutTrailingSlash(publicUrl)}/login`;
};

export const getRouterBasename = ({
  env = process.env,
  locationLike = getCurrentLocation(),
} = {}) => {
  if (ROOT_ADMIN_HOSTS.has(locationLike.hostname)) return '/';
  return env.PUBLIC_URL || '/';
};
